import { FavoritesPage } from "../pages";

export const FavoritoRoutes = [
  {
    path: '',
    element: (
      <FavoritesPage />
    ),
  },
];
